// // MODIFIED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const overtimeService = {
  /**
   * Fetches DTR Logs with OT calculations
   * @param {Object} payload { DateFrom, DateTo, LocationId, EmployeePersonalInformationId, ClassificationId }
   */
  getDtrLogs: async (apiFilterPayload, additionalApiFilterPayload) => {
    const payload = {
      maintenanceFilter: apiFilterPayload, // matches property name in C# wrapper
      additionalFilter: additionalApiFilterPayload // matches property name in C# wrapper
    };
    return await axios.post(`${domain}/api/OvertimeRequest/user-overtime`, payload, { headers });
  },

  getByEmployee: async (employeeId) => {
    return await axios.get(`${domain}/api/OvertimeRequest/employee/${employeeId}`, { headers });
  },

  create: async (payload) => {
    // This calls the controller where we added the transaction.
    // The Approval row is created on the server side now.
    return await axios.post(`${domain}/api/OvertimeRequest`, payload, { headers });
  },

  // // REMOVED: createApproval
  // Since we now handle approval creation inside the POST /api/OvertimeRequest,
  // we no longer need this method in the service layer for new requests.

  sendSmsNotification: async (data, employeeName, contacts) => {
    if (!contacts || contacts.length === 0) return;
    const formattedRef = data.referenceNumber.toString().padStart(6, "0");
    const message = `Hello,\n\n${employeeName} filed an Overtime Request.\n\nPlease check OT-${formattedRef} in the portal.`;

    const smsPromises = contacts.map(contact => {
      const smsData = {
        requestTypeId: 3,
        dateRequested: new Date(),
        message,
        recipientId: contact.id,
        recipientFullName: contact.fullName,
        recipientMobileNumber: contact.phoneNumber,
      };
      return axios.post("http://161.49.93.114:8081/api/Sms/send-sms", smsData);
    });
    return Promise.allSettled(smsPromises);
  }
};

export default overtimeService;